
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { MarketoLinkedService } from 'app/model/linkedservice/marketo.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'MarketoObject',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Marketo_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Marketo_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: MarketoLinkedService.MODEL // Linked service redefined
        }
    }
})
export class MarketoObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
